import { render, staticRenderFns } from "./indexGygl.vue?vue&type=template&id=80c4670a&scoped=true"
import script from "./indexGygl.vue?vue&type=script&lang=ts"
export * from "./indexGygl.vue?vue&type=script&lang=ts"
import style0 from "./indexGygl.vue?vue&type=style&index=0&id=80c4670a&prod&lang=scss&scoped=true"
import style1 from "./indexGygl.vue?vue&type=style&index=1&id=80c4670a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c4670a",
  null
  
)

export default component.exports